class SyntheticEvent {
  constructor(type, name, value) {
    this.type = type;
    this.target = { name, value };
  }

  getName() {
    return this.target.name;
  }

  getValue() {
    return this.target.value;
  }
}

export { SyntheticEvent };
